// "Live class Oct 30 — Build on GathrXR with ChatGPT or Claude → Register".
// Shown on the landing hero and the dashboard; hides itself once the class ends.
import React from 'react';
import { ArrowRight, Video } from 'lucide-react';
import { CURRENT_CLASS, classBannerLive } from '../../services/classEvents';
import './ClassBanner.css';

const ClassBanner: React.FC<{ variant?: 'chip' | 'bar' }> = ({ variant = 'bar' }) => {
  if (!classBannerLive()) return null;
  const day = new Date(CURRENT_CLASS.startsAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'America/New_York' });
  return (
    <a className={`clb clb-${variant}`} href="/class">
      <span className="clb-tag"><Video size={13} /> Live class {day}</span>
      <span className="clb-text">{CURRENT_CLASS.title}</span>
      <span className="clb-cta">Register <ArrowRight size={14} /></span>
    </a>
  );
};

export default ClassBanner;
